import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGlassPin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={38} height={43} fill="none" {...props}>
    <path fill="#19BCCD" d="M19 31.5 37 37 19 1z" />
    <path fill="#117B88" d="M.5 37 19 1v30.5z" />
    <path fill="#117B88" d="M19 31.5.5 37 19 42.5 37 37z" />
    <path
      stroke="#E4FFFE"
      strokeOpacity={0.38}
      strokeWidth={0.342}
      d="M37 37 19 1.2M37 37l-18-5.5M37 37l-18 5.5L.5 37M19 1.2.5 37M19 1.2v30.3M.5 37 19 31.5"
    />
  </svg>
);
export default SvgGlassPin;
